import React from 'react'
import { Image, ImageBase } from '../../../../utils/image'
import { pageheaderHeroSrc, pageheaderHeroSrcSet } from '../../../../utils/imageSizes'
import { HeroPageHeader } from '../../../sharedLayout/pageheader'
import { PageHeaderNavLayout, friendPageHeaderLinks } from '../../../sharedLayout/pageheaderUtils'

type FriendPageHeaderProps = {
  title: string
  intro: string
  image?: ImageBase
  breadcrumbs: { url: string; title: string }[]
  menuOpened?: boolean
  showSideMenu: boolean
  toggleMenu?: () => void
}

export const FriendPageHeader = (props: FriendPageHeaderProps) => {
  return (
    <HeroPageHeader
      kind="friend-spaarne"
      title={props.title}
      intro={props.intro}
      breadcrumbs={props.breadcrumbs}
      visual={
        props.image && (
          <div className="pageheader__visual">
            <div className='pageheader__visual--container'>
              <div className='fit-object'>
                {props.image ? (
                  <Image
                  src={pageheaderHeroSrc}
                  srcset={pageheaderHeroSrcSet}
                  sizes="(min-width: 81.5rem) 1224px, 100vw"
                  lazyload={false}
                  classNames={{ image: 'pageheader__image', picture: 'pageheader__wrapper' }}
                  alt={props.image.alt}
                  urls={props.image.urls}
                  width="1220"
                  height="615"
                />
              ) : undefined }
              </div>
            </div>
          </div>
        )
      }
      topTasks={
        props.showSideMenu ? (
          <PageHeaderNavLayout
            kind="friend-page"
            items={[
              ...friendPageHeaderLinks.top.map((link) => ({
                url: link.url,
                title: link.title,
                active: window.location.href === link.url,
              })),
              ...friendPageHeaderLinks.bottom.map((link) => ({
                url: link.url,
                title: link.title,
                active: window.location.href === link.url,
              })),
            ]}
            menuOpened={props.menuOpened ?? false}
            toggleMenu={props.toggleMenu}
            contactItems={[]}
          />
        ) : undefined
      }
    />
  )
}
